import React, { useMemo } from 'react';
import { Box, Field, FieldTypes, Inscription } from '@common-fe/common-fe';
import { FiservCardHolder } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';
import colors from '@/styles/colors';
import getYearsOldTitle from '@/utils/modifiers/getYearsOldTitle';

const Holder: React.FC<{ holder: FiservCardHolder }> = ({ holder }) => {
  const yearsTitle = useMemo(() => `(${getYearsOldTitle(holder.dateOfBirth)})`, [holder]);

  return (
    <Box direction="row" data-testId={`Holder_${holder.dependentId}`}>
      <Inscription margin={{ right: 'spacing4' }} truncate title={holder.name} color="textBody">
        {holder.name}
      </Inscription>
      <Inscription color="textSecondary" truncate weight="normal" title={yearsTitle}>
        {yearsTitle}
      </Inscription>
    </Box>
  );
};

interface Params {
  holders: FiservCardHolder[];
  defaultType: string | null;
}

export const useTypeForm = (params: Params) =>
  useMemo(
    (): Field[] => [
      {
        name: 'type',
        type: FieldTypes.Dropdown,
        label: 'Select dependent',
        placeholder: 'None',
        showRequireIcon: true,
        singleMode: true,
        validator: VALIDATORS.REQUIRED_STRING,
        defaultValue: params.defaultType ? params.defaultType : '',
        options: [
          {
            key: 'new',
            value: 'new',
            title: 'Create New Dependent',
            divide: params.holders.length > 0,
            textStyle: {
              color: colors.textAccent,
              fontWeight: 400,
            },
          },
          ...params.holders.map((holder) => ({
            key: holder.dependentId,
            value: holder.dependentId,
            title: holder.name,
            node: <Holder holder={holder} />,
            textStyle: {
              fontWeight: 400,
            },
          })),
        ],
      },
    ],
    [params]
  );
